var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c("em", { staticClass: "font-14", class: _vm.icon }),
        _c(
          "span",
          { staticClass: "ml-2 font-14 font-weight-normal color-secondary-6" },
          [_vm._v(" " + _vm._s(_vm.title) + " ")]
        ),
        _vm.hasEdit
          ? _c("action-button", {
              attrs: {
                i: "fas fa-edit font-16 pl-2",
                "min-width": "10px",
                variant: "outline-success ml-2 p-0"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("on-edit")
                }
              }
            })
          : _vm._e()
      ],
      1
    ),
    _c("div", { staticClass: "d-flex" }, [
      _c(
        "div",
        {
          staticClass: "data ml-3 pl-1 font-20 text-break",
          class: _vm.labelClass
        },
        [_vm._v(" " + _vm._s(_vm.value) + " ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }